import theme from './default/index';

const themeDefault = theme;
export default themeDefault;